import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import AdminPanel from "@/pages/AdminPanel";
import DeckBuilder from "@/pages/DeckBuilder";
import Campaign from "@/pages/Campaign";
import GameBoard from "@/pages/GameBoard";
import { Toaster } from "@/components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/deck-builder" element={<DeckBuilder />} />
          <Route path="/campaign" element={<Campaign />} />
          <Route path="/game/:gameId" element={<GameBoard />} />
          <Route path="/multiplayer" element={<ComingSoon page="Multiplayer Mode" />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

const ComingSoon = ({ page }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-white mb-4">{page}</h1>
        <p className="text-2xl text-gray-300">Coming in the next phase!</p>
        <a href="/" className="mt-8 inline-block text-blue-400 hover:text-blue-300 underline">
          Back to Home
        </a>
      </div>
    </div>
  );
};

export default App;
